import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateLoggerContext } from '@doxyme/analytics';
import { shouldDisableAnimation } from '../../../shared/deviceCapabilities';
import { logger } from '../uiState.slice';

/**
 * Adds styles to disable CSS animation of all elements
 */
const disableCSSAnimation = (): void => {
  const style = document.createElement('style');

  style.innerHTML = `
    body *,
    body *::before,
    body *::after {
      transition: none !important;
      animation: none !important;
    }
  `;

  document.head.append(style);
};

/**
 * Disables all CSS animation in the app and returns isAnimationDisabled value
 */
export const disableAnimationIfNeeded = createAsyncThunk<boolean>(
  'uiState/disableAnimationIfNeeded',
  async () => {
    const noAnimation = await shouldDisableAnimation();
    if (noAnimation) {
      disableCSSAnimation();
      logger.info('CSS animation is disabled');
    }

    updateLoggerContext({ isAnimationDisabled: noAnimation });

    return noAnimation;
  },
);
